import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnAgGrid from "@shared/components/Grid/SnGrid";
import { showDialog } from "@widgets/CommonDialog"; // Message Box

interface popupProps {
  modalRef?: any;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_MAS_SET_REG_003_POP_003 = forwardRef(
  ({ modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const grid1 = useRef<any>(null);

    //#endregion

    //#region Components useState
    const [columns, setColums] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any[]>([]);

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        const modifiedRows = grid1.current?.getChange();
        let lsChk: any = "2";
        if (modifiedRows.modifiedRowcount === 0) {
          lsChk = "1";
        } else {
          lsChk = "2";
        }

        if (lsChk === "1") {
          return { flag: false, message: "변경된 내용이 없습니다." };
        }
        return { flag: true };
      },
      getSelectedValue: async () => {
        await onSave(); // assumes it only saves modified rows
        return "success";
      },
      getSelectedRow: () => [grid1.current.getSelectedRows() || []],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_MAS_SET_REG_003_POP_003", {});
          setColums(rtn.grid.grid1);
          onSearch();
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    //#region onSearch
    const onSearch = async () => {
      try {
        const params = {
          id: "sn_mas_set_reg_003_pop_003_04",
          params: { cd_firm: userInfo.cd_firm },
        };

        setDataSource1([]);
        const data: any = await fnGetDataSet(params);
        setDataSource1(data[0]);

        if (data[0] && data[0].length > 0) {
          await new Promise((resolve) => setTimeout(resolve, 50));
          grid1.current.selectAndFocusRow(0);
          grid1.current.resetUpdate();
        }
      } catch (error: any) {
        showDialog("error", error.message);
      }
    };

    const onSave = async () => {
      let configIp;
      configIp = grid1.current.getChange();

      if (configIp.modifiedRowcount < 1) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      const SaveData = {
        sys_config_ip: configIp,
      };

      await fnSave("SN_MAS_SET_REG_003_SAVE_O1", SaveData);

      grid1.current?.resetUpdate();
    };
    //#endregion

    const onAddRow = async () => {
      try {
        const newRow = {};
        grid1.current?.addRow(newRow);
      } catch (error: any) {}
    };
    const onDeleteRow = async () => {
      grid1.current?.deleteSelectedRows();
    };
    //#region onGrid1BtnsClick
    const onGrid1BtnsClick = async (id: string) => {
      if (id == "addRow") {
        onAddRow();
      }
      if (id == "deleteRow") {
        onDeleteRow();
      }
    };

    const onBeforeAddRow = (newRow: RowData): boolean => {
      try {
        const allRowData: any[] = [];
        grid1.current.api.forEachNode((node: any) => {
          allRowData.push(node.data);
        });
        const maxNoLine =
          allRowData.length > 0
            ? Math.max(...allRowData.map((row: any) => row.no_line || 0))
            : 0;
        const updatedRow = {
          cd_firm: userInfo.cd_firm,
          no_line: maxNoLine + 1,
          fg_ip: "Y",
        };
        Object.assign(newRow, updatedRow);
        return true;
      } catch (error: any) {
        return false;
      }
    };
    //#endregion

    //#region UI
    return (
      <div className="h-full flex flex-col">
        <div className="flex justify-start h-full">
          <SnAgGrid
            ref={grid1}
            //
            enableAddRow={true}
            columnConfig={columns} // 컬럼 설정 전달
            rowData={dataSource1}
            isEditable={true}
            rowSelection="single"
            onBeforeAddRow={onBeforeAddRow}
            title="IP 관리"
            onBtnAddClick={onGrid1BtnsClick}
            onBtnDeleteClick={onGrid1BtnsClick}
          />
        </div>
      </div>
    );
  }
);
//#endregion

export default SN_MAS_SET_REG_003_POP_003;
